import { Component, OnInit, Input } from '@angular/core';
import { DataService } from 'src/app/services/data.service';
import { HttpClient } from '@angular/common/http';

@Component({
  selector: 'app-get-solutions',
  templateUrl: './get-solutions.component.html',
  styleUrls: ['./get-solutions.component.css']
})
export class GetSolutionsComponent implements OnInit {



  @Input() rowData: any;

  // @Output() save: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    // this.renderValue = this.value.toString().toUpperCase();

    console.log(this.rowData)

  }


  constructor(public dataService: DataService, public http: HttpClient) { }


  getSolutions() {
    // alert(this.rowData.id)
    // this
    // this.dataService.report.testSelected = this.rowData.id
    // this.dataService.report.testSelected.emit(this.rowData.id)
    this.http.get(this.dataService.serverUrl + "solution/" + this.rowData.id, {}).toPromise().then(data => {
      console.log(data);

    }).catch(err => {
      alert("Error getting Solutions")
      console.log(err);

    })
  }
}
